// ==================== 状态标签 ====================
/**
 * 任务状态标签
 */
export const ISSUE_STATUS_LABELS = {
    backlog: '待办',
    todo: '计划中',
    in_progress: '进行中',
    code_review: '代码审查',
    testing: '测试中',
    done: '已完成',
    blocked: '已阻塞',
    cancelled: '已取消',
};
/**
 * 项目状态标签
 */
export const PROJECT_STATUS_LABELS = {
    planning: '规划中',
    active: '进行中',
    completed: '已完成',
    archived: '已归档',
};
/**
 * 员工状态标签
 */
export const EMPLOYEE_STATUS_LABELS = {
    active: '在职',
    on_leave: '休假中',
    resigned: '已离职',
};
/**
 * 设备状态标签
 */
export const DEVICE_STATUS_LABELS = {
    available: '可用',
    assigned: '已分配',
    maintenance: '维修中',
    retired: '已报废',
};
/**
 * 请假状态标签
 */
export const LEAVE_STATUS_LABELS = {
    draft: '草稿',
    pending: '待审批',
    approved: '已批准',
    rejected: '已拒绝',
    cancelled: '已取消',
};
/**
 * 报销状态标签
 */
export const REIMBURSEMENT_STATUS_LABELS = {
    pending: '待审批',
    approved: '已批准',
    rejected: '已拒绝',
    paid: '已付款',
    cancelled: '已取消',
};
/**
 * 里程碑状态标签
 */
export const MILESTONE_STATUS_LABELS = {
    open: '进行中',
    closed: '已关闭',
};
/**
 * 团队状态标签
 */
export const TEAM_STATUS_LABELS = {
    active: '活跃',
    archived: '已归档',
};
/**
 * 工资单状态标签
 */
export const PAYSLIP_STATUS_LABELS = {
    draft: '草稿',
    pending: '待审批',
    approved: '已批准',
    paid: '已发放',
};
// ==================== 优先级标签 ====================
/**
 * 任务优先级标签
 */
export const PRIORITY_LABELS = {
    urgent: '紧急',
    high: '高',
    medium: '中',
    low: '低',
};
// ==================== 类型标签 ====================
/**
 * 任务类型标签
 */
export const ISSUE_TYPE_LABELS = {
    epic: '史诗',
    story: '故事',
    task: '任务',
    bug: '缺陷',
};
/**
 * 请假类型标签
 */
export const LEAVE_TYPE_LABELS = {
    annual: '年假',
    sick: '病假',
    personal: '事假',
    marriage: '婚假',
    maternity: '产假',
    paternity: '陪产假',
    bereavement: '丧假',
};
/**
 * 报销类型标签
 */
export const REIMBURSEMENT_TYPE_LABELS = {
    travel: '差旅',
    office: '办公',
    meal: '餐饮',
    transport: '交通',
    other: '其他',
};
/**
 * 设备类型标签
 */
export const DEVICE_TYPE_LABELS = {
    computer: '电脑',
    monitor: '显示器',
    keyboard: '键盘',
    mouse: '鼠标',
    other: '其他',
};
//# sourceMappingURL=labels.js.map